export enum ApiStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Error = 'Error',
  NotExecuted = 'NotExecuted'
}

export enum ResourceType {
  PASSWORDS = 'passwords',
  CERTIFICATES = 'certificates'
}
